module.exports = __webpack_public_path__ + "img/路透社@2x.ca952f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/路透社@2x.png
// module id = IMuk
// module chunks = 3